<template>
    <ul class="details-nav-type-1" v-if="visibleWidgets.length">
        <li 
            v-for="widget in visibleWidgets" 
            :key="widget.id"
            :class="[{ 'is-hidden': widget.hidden }]"
        >
            <div class="name" @click="!widget.hidden && navigateToWidget(widget.id)">{{ $t(widget.titleKey || widget.id) }}</div>
            <div class="status" v-if="!widget.hidden">
                <div v-if="widget.loading && !widget.loaded" class="loading-spinner-type-1 primary"></div>
                <div v-if="!widget.loaded && !widget.loading" class="indicator not-loaded"></div>
                <div v-if="widget.toggle && !widget.loading" class="indicator open" @click="closeWidget(widget.id)"></div>
            </div>
            <div class="actions" v-if="!widget.hidden">
                <button class="btn-s-icon set-default-toggle" :class="getWidgetToggle(widget.id) ? 'btn-1' : 'btn-5'" @click="setWidgetToggle(widget.id, !getWidgetToggle(widget.id))" v-tooltip="'tooltips.widget_star'">
                    <div class="icon-star-pos"></div>
                </button>
                <button class="btn-7 btn-s-icon move-up" :disabled="isFirstWidget(widget.id)" @click="moveWidgetUp(widget.id)" v-tooltip="'tooltips.widget_up'">
                    <div class="icon-arrow-pos"></div>
                </button>
                <button class="btn-6 btn-s-icon move-down" :disabled="isLastWidget(widget.id)" @click="moveWidgetDown(widget.id)" v-tooltip="'tooltips.widget_down'">
                    <div class="icon-arrow-pos"></div>
                </button>
            </div>
        </li>
    </ul>
</template>

<script>
    import { useCompanyWidgetsStore } from '@/stores/companyWidgets';
    import { mapActions } from 'pinia';

    export default {
        name: "CompanyDetailsNav",
        computed: {
            visibleWidgets() {
                return useCompanyWidgetsStore().getVisibleWidgets();
            }
        },
        methods: {
            ...mapActions(useCompanyWidgetsStore, [
                'navigateToWidget', 
                'closeWidget',
                'moveWidgetUp', 
                'moveWidgetDown', 
                'setWidgetToggle',
                'getWidgetToggle'
            ]),
            // isFirstWidget(id) {
            //     return this.visibleWidgets[0].id === id;
            // },
            // isLastWidget(id) {
            //     return this.visibleWidgets[this.visibleWidgets.length - 1].id === id;
            // }
            isFirstWidget(id) {
                const visibles = this.visibleWidgets.filter(w => !w.hidden);
                if (!visibles.length) return false;
                return visibles[0].id === id;
            },
            isLastWidget(id) {
                const visibles = this.visibleWidgets.filter(w => !w.hidden);
                if (!visibles.length) return false;
                return visibles[visibles.length - 1].id === id;
            }
        }
    }
</script>